/* kc-options.js — Koval Customs native product options (Globo replacement) v2
   - renders option sets from kc-options-config.json (trimmed Globo format)
   - REAL variant pricing: values with `pv` select the product's own variant
     (hoodie/tshirt each have their own price); addons only for personalization
   - live font/color preview on text inputs (applies_to), inline rows, addon cards
   - cart contract identical to Globo: properties[label_on_cart], _has_gpo,
     _gpo_product_group + addon lines with _gpo_parent_product_group/_gpo_field_name
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-kc-options]');
  if (!root) return;
  var PRODUCT_ID = root.getAttribute('data-product-id');
  var PRODUCT_HANDLE = root.getAttribute('data-product-handle');
  var CONFIG_URL = root.getAttribute('data-config-url');
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KCO_US = ROOT.indexOf('/en-us') === 0 || location.pathname.indexOf('/en-us/') === 0;
  var MONEY = function (cents) {
    if (KCO_US) return '$' + (cents / 100).toFixed(2);
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  };

  var SET = null, SET_ID = '';
  var BASE_VARIANT = 0, BASE_PRICE = 0;        // fallback from config
  var SELECTED_VARIANT = 0;                    // real product variant in the cart
  var PRODUCT_DATA = null;                     // live /products/<handle>.js
  var els = {}, nodes = {}, values = {}, parentOf = {};
  var badgeRefs = {};                          // variant_id/pv -> [badge spans]
  var cardBodies = [];                         // [{body, ids:[dep ids]}]
  // 10.10 b10: miniatury z Shopify CDN (/files/) w rozmiarze do wyswietlenia (bylo 700-1024 px przy 40-82 px na ekranie)
  function kcoThumb(u, w) {
    if (!u || /[?&]width=/.test(u) || !/(cdn\.shopify\.com\/s\/files\/|\/cdn\/shop\/files\/)/.test(u)) return u;
    return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + (w || 200);
  }
  var garmentTiles = [];                       // [{ov, canvas}] for the placement preview
  var absBadges = [];                          // [{ov, span}] computed base+addon prices (zip fallback)
  var ASSET_BASE = (CONFIG_URL || '').split('kc-options-config.json')[0];

  function norm(s) {
    return String(s == null ? '' : s).trim().replace(/\s+/g, ' ').toLowerCase();
  }
  function plOnly(s) {
    // bilingual "Polski - English" labels -> Polish part only
    s = String(s == null ? '' : s);
    var cut = s.split(/\s+[-–]\s+/)[0];
    return cut.trim();
  }
  function enOnly(s) {
    s = String(s == null ? '' : s);
    var parts = s.split(/\s+[-\u2013]\s+/);
    return (parts.length > 1 ? parts[parts.length - 1] : parts[0]).trim();
  }
  function disp(el) {
    if (KCO_US) return el.display_en || enOnly(el.label || el.display || '');
    return plOnly(el.display || el.label || '');
  }
  function vdisp(ov) {
    if (KCO_US) return ov.display_en || enOnly(ov.value || '');
    return ov.display || plOnly(ov.value || '');
  }
  /* US cart: customer-facing property keys/values in English; Polish originals kept as hidden _<key>
     properties so fulfilment (Make 9697561, prep_order.py) keeps reading the same data */
  var FILE_KEYS = {}, FILE_N = 0;
  function fileKeyEn(el) {
    if (!FILE_KEYS[el.id]) { FILE_N++; FILE_KEYS[el.id] = el.cart_en || (FILE_N === 1 ? 'Photo' : 'Photo ' + FILE_N); }
    return FILE_KEYS[el.id];
  }
  function cartKeyEn(el) {
    var k = el.cart_en || el.display_en || enOnly(el.label || el.label_on_cart || el.id);
    return String(k).replace(/\s*\([^)]*\)\s*$/, '').replace(/\s*\((optional|e\.g\.[^)]*)\)/gi, '').trim() || (el.label_on_cart || el.id);
  }
  function cartValEn(el, v) {
    var hit = (el.values || []).filter(function (ov) { return norm(ov.value) === norm(v); })[0];
    return hit ? vdisp(hit) : v;
  }
  function stripUsHidden(list) {
    for (var i = list.length - 1; i >= 0; i--) {
      var e = list[i];
      if (e.type === 'group') {
        stripUsHidden(e.elements || []);
        if (!(e.elements || []).length) list.splice(i, 1);
        continue;
      }
      if (e.us_hide) { list.splice(i, 1); continue; }
      if (e.values) e.values = e.values.filter(function (v) { return !v.us_hide; });
    }
  }

  /* field order: Rodzaj produktu -> Rozmiar -> Rozmiar dziecięcy -> (size chart) -> colors */
  function reorderCommonFields(arr) {
    arr.forEach(function (el) { if (el.elements) reorderCommonFields(el.elements); });
    var ids = arr.map(function (e) { return e.id; });
    if (ids.indexOf('image-swatches-1') < 0) return;
    var moved = [];
    ['size-chart-1', 'buttons-2', 'checkbox-1', 'buttons-1'].forEach(function (id) {
      var i = -1;
      arr.some(function (e, k) { if (e.id === id) { i = k; return true; } return false; });
      if (i >= 0) moved.push(arr.splice(i, 1)[0]);
    });
    var anchor = -1;
    arr.some(function (e, k) { if (e.id === 'image-swatches-1') { anchor = k; return true; } return false; });
    moved.reverse().forEach(function (m) { arr.splice(anchor + 1, 0, m); });
  }

  /* every font picker gets: inline row with its color picker + live preview on the nearest text field */
  function pairFontColor(arr) {
    for (var i = 0; i < arr.length; i++) {
      var el = arr[i];
      if (el.elements) pairFontColor(el.elements);
      if (el.type !== 'google-font') continue;
      if (!el.applies_to) {
        for (var j = i - 1; j >= 0; j--) {
          if (arr[j].type === 'text' || arr[j].type === 'textarea') { el.applies_to = arr[j].id; break; }
        }
      }
      if (!el.display) el.display = 'Czcionka';
      for (var k = i + 1; k <= i + 2 && k < arr.length; k++) {
        if (arr[k].type === 'color-picker') {
          var key = el.inline || arr[k].inline || ('fr_' + el.id);
          el.inline = el.inline || key;
          arr[k].inline = arr[k].inline || key;
          if (!arr[k].applies_to) arr[k].applies_to = el.applies_to;
          if (!arr[k].display || /color\s*picker/i.test(arr[k].label || '')) arr[k].display = 'Kolor napisu';
          break;
        }
      }
    }
  }

  /* ---------- visibility (CLO) ---------- */
  function cloVisible(el) {
    var clo = el.clo;
    if (!clo || !clo.whens || !clo.whens.length) return true;
    var results = clo.whens.map(function (w) {
      var eq = norm(values[w.select]) === norm(w.value);
      return w.where === 'NOT_EQUALS' ? !eq : eq;
    });
    var cond = clo.match === 'any' ? results.some(Boolean) : results.every(Boolean);
    return clo.display === 'hide' ? !cond : cond;
  }
  function isVisible(id) {
    var el = els[id];
    if (!el) return false;
    if (!cloVisible(el)) return false;
    var p = parentOf[id];
    while (p) {
      if (!cloVisible(els[p])) return false;
      p = parentOf[p];
    }
    return true;
  }
  function refresh() {
    Object.keys(els).forEach(function (id) {
      var n = nodes[id];
      if (n) n.classList.toggle('kco-hidden', !isVisible(id));
    });
    cardBodies.forEach(function (cb) {
      var any = cb.ids.some(function (id) { return isVisible(id); });
      cb.body.classList.toggle('kco-hidden', !any);
    });
    // value-level hide rules (e.g. no chest placement on zip-up hoodies)
    garmentTiles.forEach(function (t) {
      var hw = t.ov.hide_when;
      if (!hw || !t.tile) return;
      var hidden = norm(values[hw.select]) === norm(hw.value);
      t.tile.classList.toggle('kco-hidden', hidden);
      if (hidden && norm(values[t.elId]) === norm(t.ov.value)) {
        values[t.elId] = '';
        t.tile.classList.remove('is-active');
      }
    });
    updatePrice();
    renderGarments();
  }

  /* ---------- garment placement preview (selected product type + color) ---------- */
  var GARMENT_OF = function (v) {
    v = norm(v);
    if (v.indexOf('koszulka') >= 0) return 'tshirt';
    if (v.indexOf('bez kaptura') >= 0) return 'crew';
    if (v.indexOf('rozpinana') >= 0) return 'zip';
    return 'hoodie';
  };
  var MARKS = {
    tshirt: { 'front-center': [500, 430, 300, 175], 'front-left': [350, 340, 135, 85], 'front-right': [650, 340, 135, 85], back: [500, 430, 330, 195] },
    crew:   { 'front-center': [500, 440, 290, 170], 'front-left': [355, 345, 130, 82], 'front-right': [645, 345, 130, 82], back: [500, 440, 300, 180] },
    hoodie: { 'front-center': [500, 475, 250, 140], 'front-left': [365, 370, 120, 76], 'front-right': [635, 370, 120, 76], back: [500, 430, 300, 180] },
    zip:    { 'front-center': [500, 475, 250, 140], 'front-left': [360, 380, 120, 76], 'front-right': [640, 380, 120, 76], back: [500, 430, 300, 180] }
  };
  var garmentImgs = {};
  function garmentImg(garment, side) {
    var key = garment + '-' + side;
    if (!garmentImgs[key]) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = ASSET_BASE + 'kc-garment-' + key + '.png';
      img.onload = function () { lastGarmentKey = ''; renderGarments(); };
      garmentImgs[key] = img;
    }
    return garmentImgs[key];
  }
  function hexLum(hex) {
    var n = parseInt(hex.slice(1), 16);
    return 0.299 * (n >> 16 & 255) + 0.587 * (n >> 8 & 255) + 0.114 * (n & 255);
  }
  function currentGarmentColor() {
    var ids = ['image-swatches-6', 'image-swatches-5', 'image-swatches-4', 'kc-zip-colors'];
    for (var i = 0; i < ids.length; i++) {
      var el = els[ids[i]];
      if (!el || !isVisible(ids[i])) continue;
      var v = values[ids[i]];
      var ov = (el.values || []).filter(function (o) { return norm(o.value) === norm(v); })[0];
      if (ov && ov.hex) return ov.hex;
    }
    return '#303030';
  }
  var lastGarmentKey = '';
  function renderGarments() {
    if (!garmentTiles.length) return;
    var garment = GARMENT_OF(values['image-swatches-1'] || '');
    var hex = currentGarmentColor();
    var key = garment + hex;
    if (key === lastGarmentKey) return;
    var allReady = true;
    garmentTiles.forEach(function (t) {
      var side = t.ov.pos === 'back' ? 'back' : 'front';
      var img = garmentImg(garment, side);
      if (!img.complete || !img.naturalWidth) { allReady = false; return; }
      var c = t.canvas, ctx = c.getContext('2d'), S = c.width;
      ctx.clearRect(0, 0, S, S);
      // tint white garment with the chosen color (skip near-white)
      var off = document.createElement('canvas');
      off.width = off.height = S;
      var octx = off.getContext('2d');
      octx.drawImage(img, 0, 0, S, S);
      if (hexLum(hex) < 235) {
        octx.globalCompositeOperation = 'multiply';
        octx.fillStyle = hex;
        octx.fillRect(0, 0, S, S);
        octx.globalCompositeOperation = 'destination-in';
        octx.drawImage(img, 0, 0, S, S);
      }
      ctx.drawImage(off, 0, 0);
      // placement marker
      var m = (MARKS[garment] || {})[t.ov.pos];
      if (m) {
        var s = S / 1000;
        var w = m[2] * s, hh = m[3] * s, x = m[0] * s - w / 2, y = m[1] * s - hh / 2;
        var ink = hexLum(hex) > 150 ? '#1A1A1A' : '#FFFFFF';
        ctx.save();
        ctx.strokeStyle = ink;
        ctx.lineWidth = Math.max(1.4, 2.2 * s * 5);
        ctx.setLineDash([7 * s * 5, 5 * s * 5]);
        if (ctx.roundRect) {
          ctx.beginPath();
          ctx.roundRect(x, y, w, hh, 8 * s * 5);
          ctx.stroke();
        } else {
          ctx.strokeRect(x, y, w, hh);
        }
        ctx.setLineDash([]);
        ctx.fillStyle = ink;
        ctx.font = '700 ' + Math.round(hh * 0.42) + 'px "Hanken Grotesk",sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(KCO_US ? 'DESIGN' : 'WZÓR', m[0] * s, m[1] * s + 1, w * 0.86);
        ctx.restore();
      }
    });
    if (allReady) lastGarmentKey = key;
  }

  /* ---------- pricing ---------- */
  function variantPrice(variantId, fallbackCents) {
    if (PRODUCT_DATA) {
      var v = (PRODUCT_DATA.variants || []).filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (v) return v.price;
    }
    return fallbackCents;
  }
  function selectedAddons() {
    var out = [];
    Object.keys(els).forEach(function (id) {
      var el = els[id];
      if (!el.values || !isVisible(id)) return;
      var v = values[id];
      if (!v) return;
      el.values.forEach(function (ov) {
        if (ov.variant_id && norm(ov.value) === norm(v)) {
          out.push({
            variant_id: ov.variant_id,
            price: Math.round(parseFloat(ov.variant_price || '0') * 100),
            field: el.label_on_cart || el.id
          });
        }
      });
    });
    return out;
  }
  function currentBase() {
    return variantPrice(SELECTED_VARIANT, BASE_PRICE);
  }
  function qty() {
    var input = document.querySelector('.quantity__input[name="quantity"], input[name="quantity"]');
    return (input && parseInt(input.value, 10)) || 1;
  }
  function resolveAxes() {
    var ax = SET && SET.variant_axes;
    if (!ax || !PRODUCT_DATA) return;
    var c = values[ax.color], s = values[ax.size];
    if (!c || !s) return;
    var hit = null;
    (PRODUCT_DATA.variants || []).forEach(function (v) {
      var opts = (v.options || []).map(function (o) { return norm(o); });
      if (opts.indexOf(norm(c)) > -1 && opts.indexOf(norm(s)) > -1) hit = v;
    });
    if (hit) SELECTED_VARIANT = hit.id;
  }
  function updatePrice() {
    resolveAxes();
    absBadges.forEach(function (b) {
      b.span.textContent = MONEY(BASE_PRICE + Math.round(parseFloat(b.ov.variant_price || '0') * 100));
    });
    var addons = selectedAddons();
    var extra = addons.reduce(function (s, a) { return s + a.price; }, 0);
    var total = currentBase() + extra;
    var totalEl = root.querySelector('.kco-total');
    var extraEl = root.querySelector('.kco-total-extra');
    if (totalEl) totalEl.textContent = MONEY(total);
    if (extraEl) {
      extraEl.textContent = extra > 0 ? ((KCO_US ? 'incl. add-ons +' : 'w tym dodatki +') + MONEY(extra)) : '';
      extraEl.style.display = extra > 0 ? '' : 'none';
    }
    syncThemePrice(total);
  }
  /* keep the theme's own price display in sync (kills Globo's stale 210/230 mismatch) */
  function syncThemePrice(totalCents) {
    var txt = MONEY(totalCents);
    document.querySelectorAll('.productView-info .price, .productView-price .price, .product__price .price, .price__current, [data-product-price]').forEach(function (n) {
      n.textContent = txt;
    });
    // Halo fallback: any standalone "NNN,NN PLN/zł" price node inside product info
    document.querySelectorAll('.productView-info span, .productView-info div').forEach(function (n) {
      if (n.children.length === 0 && /^\s*(\$\s*\d[\d\s]*[.,]\d{2}|\d[\d\s]*[.,]\d{2}\s*(PLN|zł|USD))\s*$/.test(n.textContent)) n.textContent = txt;
    });
  }

  /* ---------- DOM helpers ---------- */
  function h(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function regBadge(key, b) {
    (badgeRefs[key] = badgeRefs[key] || []).push(b);
    return b;
  }
  function priceBadge(ov) {
    if (ov.pv) {
      var cents = Math.round(parseFloat(ov.pv_price || '0') * 100);
      return regBadge('pv' + ov.pv, h('span', 'kco-price-badge kco-price-badge--abs', cents ? MONEY(cents) : ''));
    }
    if (ov.abs_on_base) {
      var ab = h('span', 'kco-price-badge kco-price-badge--abs', '');
      absBadges.push({ ov: ov, span: ab });
      return ab;
    }
    if (!ov.variant_price || !parseFloat(ov.variant_price)) return null;
    return regBadge(ov.variant_id, h('span', 'kco-price-badge', '+' + MONEY(Math.round(parseFloat(ov.variant_price) * 100))));
  }
  function labelRow(el) {
    var row = h('div', 'kco-label-row');
    var lab = h('span', 'kco-label', disp(el));
    row.appendChild(lab);
    if (el.required) lab.appendChild(h('span', 'kco-req', ' *'));
    return row;
  }
  function helpText(el) {
    var ht = KCO_US ? el.helptext_en : el.helptext;
    return ht ? h('div', 'kco-help', ht) : null;
  }
  function setValue(id, v) {
    values[id] = v;
    var n = nodes[id];
    if (n) n.classList.remove('kco-invalid');
    refresh();
    kcoEmit(id);
  }
  // 10.10 kreator nadrukow: hook dla podgladu na zywo (kc-nadruk-ui.js). Bez sluchaczy nic nie zmienia.
  function kcoEmit(id) {
    var K = window.KCO;
    if (K) K._l.forEach(function (f) { try { f(id); } catch (e) { console.error('[KCO]', e); } });
  }
  window.KCO = { root: root, values: values, els: els, nodes: nodes, isVisible: isVisible, set: setValue, hooks: {}, _l: [], ready: false,
    on: function (f) { this._l.push(f); } };

  /* ---------- live font/color preview ---------- */
  var fontCssLoaded = {};
  function loadFontCss(fam) {
    if (fontCssLoaded[fam]) return;
    fontCssLoaded[fam] = true;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=' + encodeURIComponent(fam).replace(/%20/g, '+') + '&display=swap';
    document.head.appendChild(link);
  }
  function previewTarget(el) {
    if (!el.applies_to) return null;
    var t = nodes[el.applies_to];
    return t ? t.querySelector('input,textarea') : null;
  }
  function applyFont(el, fam) {
    var inp = previewTarget(el);
    if (!inp) return;
    loadFontCss(fam);
    inp.style.setProperty('font-family', '"' + fam + '"', 'important');
    inp.classList.add('kco-input--preview');
  }
  function applyColor(el, color) {
    var inp = previewTarget(el);
    if (!inp) return;
    inp.style.setProperty('color', color, 'important');
    inp.classList.add('kco-input--preview');
  }

  /* ---------- renderers ---------- */
  var renderers = {
    heading: function (el) {
      var txt = KCO_US ? (el.display_en || enOnly(el.text || el.display || '')) : plOnly(el.display || el.text || '');
      // Globo sets often carry a second, fully-English heading -> drop it (PL mode);
      // in US mode drop untranslated Polish headings instead
      var noPolish = !/[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/.test(txt);
      var looksEnglish = /\b(the|and|your|for|with|create|design|add|second|one|set|you)\b/i.test(txt);
      if (!KCO_US && noPolish && looksEnglish) return h('span', 'kco-hidden');
      if (KCO_US && !noPolish && !el.display_en) return h('span', 'kco-hidden');
      var tag = el.style === 'h2' ? 'h2' : 'h4';
      return h(tag, 'kco-heading kco-heading--' + (el.style || 'h4'), txt);
    },
    divider: function () { return h('hr', 'kco-divider'); },
    spacing: function () { return h('div', 'kco-spacing'); },

    text: function (el) {
      var wrap = h('div', 'kco-field');
      wrap.appendChild(labelRow(el));
      var input = h('input', 'kco-input');
      input.type = 'text';
      if (el.placeholder) input.placeholder = el.placeholder;
      input.addEventListener('input', function () { setValue(el.id, input.value); });
      wrap.appendChild(input);
      var help = helpText(el);
      if (help) wrap.appendChild(help);
      return wrap;
    },

    textarea: function (el) {
      var wrap = h('div', 'kco-field');
      wrap.appendChild(labelRow(el));
      var input = h('textarea', 'kco-input kco-textarea');
      input.rows = el.rows || 4;
      input.addEventListener('input', function () { setValue(el.id, input.value); });
      wrap.appendChild(input);
      var help = helpText(el);
      if (help) wrap.appendChild(help);
      return wrap;
    },

    /* plain checkbox -> modern switch row (value text shown via ov.display) */
    checkbox: function (el) {
      var wrap = h('div', 'kco-field kco-field--checkbox');
      wrap.appendChild(labelRow(el));
      (el.values || []).forEach(function (ov) {
        wrap.appendChild(switchRow(el, ov, vdisp(ov)));
      });
      var help = helpText(el);
      if (help) wrap.appendChild(help);
      return wrap;
    },

    buttons: function (el) {
      var wrap = h('div', 'kco-field');
      wrap.appendChild(labelRow(el));
      var row = h('div', 'kco-pills');
      (el.values || []).forEach(function (ov) {
        var b = h('button', 'kco-pill', vdisp(ov));
        b.type = 'button';
        b.addEventListener('click', function () {
          row.querySelectorAll('.kco-pill').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          setValue(el.id, ov.value);
        });
        row.appendChild(b);
      });
      wrap.appendChild(row);
      var help = helpText(el);
      if (help) wrap.appendChild(help);
      return wrap;
    },

    'image-swatches': function (el) {
      var wrap = h('div', 'kco-field');
      var lr = labelRow(el);
      var selPrice = h('span', 'kco-sel-price');
      lr.appendChild(selPrice);
      wrap.appendChild(lr);
      if (el.garment_preview) {
        var ggrid = h('div', 'kco-swatches kco-swatches--garment');
        (el.values || []).forEach(function (ov) {
          var tile = h('button', 'kco-swatch kco-swatch--garment');
          tile.type = 'button';
          var canvas = h('canvas');
          canvas.width = canvas.height = 220;
          tile.appendChild(canvas);
          tile.appendChild(h('span', 'kco-garment-caption', vdisp(ov)));
          var gb = priceBadge(ov);
          if (gb) tile.appendChild(gb);
          garmentTiles.push({ ov: ov, canvas: canvas, tile: tile, elId: el.id });
          tile.addEventListener('click', function () {
            ggrid.querySelectorAll('.kco-swatch').forEach(function (x) { x.classList.remove('is-active'); });
            tile.classList.add('is-active');
            selPrice.textContent = (ov.variant_price && parseFloat(ov.variant_price)) ? '(+ ' + MONEY(parseFloat(ov.variant_price) * 100) + ')' : '';
            setValue(el.id, ov.value);
          });
          ggrid.appendChild(tile);
        });
        wrap.appendChild(ggrid);
        var ghelp = helpText(el);
        if (ghelp) wrap.appendChild(ghelp);
        return wrap;
      }
      var grid = h('div', 'kco-swatches');
      (el.values || []).forEach(function (ov) {
        var tile = h('button', 'kco-swatch');
        tile.type = 'button';
        tile.title = vdisp(ov);
        var imgSrc = ov.img || (ov.img_asset ? ASSET_BASE + ov.img_asset : null);
        if (imgSrc) {
          var img = h('img');
          img.loading = 'lazy';
          img.src = kcoThumb(imgSrc);
          img.alt = ov.value;
          tile.appendChild(img);
        } else if (ov.hex) {
          var disc = h('span', 'kco-color-disc');
          disc.style.background = ov.hex;
          disc.title = vdisp(ov);
          tile.appendChild(disc);
        } else {
          tile.appendChild(h('span', 'kco-swatch-text', vdisp(ov)));
        }
        var badge = priceBadge(ov);
        if (badge) tile.appendChild(badge);
        if (el.show_names) {
          tile.classList.add('kco-swatch--named');
          tile.appendChild(h('span', 'kco-swatch-name', vdisp(ov)));
        }
        tile.addEventListener('click', function () {
          if (tile.classList.contains('is-active') && !el.required && !ov.pv) {
            // optional pickers (e.g. Kreatywny haft) can be unselected
            tile.classList.remove('is-active');
            selPrice.textContent = '';
            setValue(el.id, '');
            return;
          }
          grid.querySelectorAll('.kco-swatch').forEach(function (x) { x.classList.remove('is-active'); });
          tile.classList.add('is-active');
          if (ov.pv) {
            SELECTED_VARIANT = ov.pv;
            selPrice.textContent = '';
          } else if (ov.abs_on_base) {
            SELECTED_VARIANT = BASE_VARIANT; // addon prices on top of the BASE garment (Globo model)
            selPrice.textContent = '';
          } else {
            selPrice.textContent = (ov.variant_price && parseFloat(ov.variant_price)) ? '(+ ' + MONEY(parseFloat(ov.variant_price) * 100) + ')' : '';
          }
          setValue(el.id, ov.value);
        });
        grid.appendChild(tile);
      });
      wrap.appendChild(grid);
      var help = helpText(el);
      if (help) wrap.appendChild(help);
      return wrap;
    },

    'image-dropdown': function (el) {
      var wrap = h('div', 'kco-field');
      wrap.appendChild(labelRow(el));
      var dd = h('div', 'kco-dropdown');
      var btn = h('button', 'kco-dropdown-btn');
      btn.type = 'button';
      var btnImg = h('img', 'kco-dropdown-btn-img');
      var btnText = h('span', null, (el.placeholder && !/select/i.test(el.placeholder)) ? el.placeholder : (KCO_US ? '-- Select --' : '-- Wybierz --'));
      btn.appendChild(btnImg); btnImg.style.display = 'none';
      btn.appendChild(btnText);
      btn.appendChild(h('span', 'kco-caret'));
      var list = h('div', 'kco-dropdown-list');
      (el.values || []).forEach(function (ov) {
        var item = h('button', 'kco-dropdown-item');
        item.type = 'button';
        if (ov.img) {
          var img = h('img');
          img.loading = 'lazy';
          img.src = kcoThumb(ov.img);
          item.appendChild(img);
        }
        item.appendChild(h('span', null, vdisp(ov)));
        var badge = priceBadge(ov);
        if (badge) item.appendChild(badge);
        item.addEventListener('click', function () {
          btnText.textContent = vdisp(ov);
          if (ov.img) { btnImg.src = kcoThumb(ov.img); btnImg.style.display = ''; } else { btnImg.style.display = 'none'; }
          dd.classList.remove('is-open');
          setValue(el.id, ov.value);
        });
        list.appendChild(item);
      });
      btn.addEventListener('click', function () { dd.classList.toggle('is-open'); });
      document.addEventListener('click', function (e) {
        if (!dd.contains(e.target)) dd.classList.remove('is-open');
      });
      dd.appendChild(btn);
      dd.appendChild(list);
      wrap.appendChild(dd);
      return wrap;
    },

    'color-picker': function (el) {
      var wrap = h('div', 'kco-field');
      wrap.appendChild(labelRow(el));
      var row = h('div', 'kco-color-row');
      var input = h('input', 'kco-color');
      input.type = 'color';
      input.value = '#1a1a1a';
      var hex = h('span', 'kco-color-hex', '');
      input.addEventListener('input', function () {
        hex.textContent = input.value;
        applyColor(el, input.value);
        setValue(el.id, input.value);
      });
      row.appendChild(input);
      row.appendChild(hex);
      wrap.appendChild(row);
      return wrap;
    },

    'google-font': function (el) {
      var wrap = h('div', 'kco-field');
      wrap.appendChild(labelRow(el));
      var dd = h('div', 'kco-dropdown kco-fontdrop');
      var btn = h('button', 'kco-dropdown-btn');
      btn.type = 'button';
      var btnText = h('span', null, (el.placeholder && !/select/i.test(el.placeholder)) ? el.placeholder : (KCO_US ? '-- Choose a font --' : '-- Wybierz czcionkę --'));
      btn.appendChild(btnText);
      btn.appendChild(h('span', 'kco-caret'));
      var list = h('div', 'kco-dropdown-list');
      var loaded = false;
      function loadAll() {
        if (loaded) return;
        loaded = true;
        (el.values || []).forEach(function (ov) { loadFontCss(ov.value); });
      }
      (el.values || []).forEach(function (ov) {
        var item = h('button', 'kco-dropdown-item kco-font-item');
        item.type = 'button';
        var sp = h('span', null, ov.value);
        sp.style.setProperty('font-family', '"' + ov.value + '"', 'important');
        item.appendChild(sp);
        item.addEventListener('click', function () {
          btnText.textContent = ov.value;
          btnText.style.setProperty('font-family', '"' + ov.value + '"', 'important');
          dd.classList.remove('is-open');
          applyFont(el, ov.value);
          setValue(el.id, ov.value);
        });
        list.appendChild(item);
      });
      btn.addEventListener('click', function () { loadAll(); dd.classList.toggle('is-open'); });
      document.addEventListener('click', function (e) {
        if (!dd.contains(e.target)) dd.classList.remove('is-open');
      });
      dd.appendChild(btn);
      dd.appendChild(list);
      wrap.appendChild(dd);
      return wrap;
    },

    'size-chart': function (el) {
      var wrap = h('div', 'kco-field kco-field--sizechart');
      var link = h('button', 'kco-chartlink');
      link.type = 'button';
      link.appendChild(h('span', 'kco-chartlink-text', KCO_US ? (el.display_en || ((el.id === 'size-chart-2') ? 'Color chart' : 'Size chart & specifications')) : plOnly(el.display || ((el.id === 'size-chart-2') ? 'Kolorystyka nici' : 'Tabela rozmiarów i specyfikacja'))));
      var arrow = h('span', 'kco-chartlink-arrow');
      arrow.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg>';
      link.appendChild(arrow);
      link.addEventListener('click', function () {
        var overlay = h('div', 'kco-modal');
        var box = h('div', 'kco-modal-box');
        var close = h('button', 'kco-modal-close', '✕');
        close.type = 'button';
        close.addEventListener('click', function () { overlay.remove(); });
        overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.remove(); });
        var content = h('div', 'kco-modal-content');
        content.innerHTML = (KCO_US && el.text_en) ? el.text_en : (el.text || '');
        content.querySelectorAll('img').forEach(function (img) { img.removeAttribute('style'); });
        box.appendChild(close);
        box.appendChild(content);
        overlay.appendChild(box);
        document.body.appendChild(overlay);
      });
      wrap.appendChild(link);
      var hintTxt = KCO_US ? (el.hint_en || ((el.id === 'size-chart-2') ? 'Check the colors before you order' : 'Check the specs and size chart before you order')) : el.hint;
      if (hintTxt) wrap.appendChild(h('div', 'kco-chartlink-hint', hintTxt));
      return wrap;
    },

    file: function (el) {
      var wrap = h('div', 'kco-field');
      wrap.appendChild(labelRow(el));
      var input = h('input', 'kco-file');
      input.type = 'file';
      input.accept = 'image/png,image/jpeg,image/webp,image/heic,.pdf';
      input.dataset.kcoFile = KCO_US ? fileKeyEn(el) : (el.label_on_cart || el.id);
      input.dataset.kcoFileId = el.id;
      input.style.display = 'none';
      var zone = h('label', 'kco-upload');
      zone.appendChild(input);
      var idle = h('div', 'kco-upload-idle');
      // style="fill:none" inline beats theme svg{fill:...} rules (the "pink square" bug)
      idle.innerHTML = '<svg viewBox="0 0 24 24" style="fill:none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 17V9"/><path d="m8.5 12 3.5-3.5L15.5 12"/><path d="M20 16.6A4.5 4.5 0 0 0 17.5 8.4 6 6 0 0 0 6 9.7a4 4 0 0 0-1.5 7.8"/></svg>';
      idle.appendChild(h('div', 'kco-upload-cta', KCO_US ? 'Click to add a photo' : 'Kliknij, aby dodać zdjęcie'));
      idle.appendChild(h('div', 'kco-upload-sub', KCO_US ? 'JPG, PNG or HEIC · straight from your phone' : 'JPG, PNG lub HEIC · prosto z telefonu'));
      var done = h('div', 'kco-upload-done');
      done.style.display = 'none';
      var thumb = h('img', 'kco-upload-thumb');
      var fname = h('span', 'kco-upload-name', '');
      var clear = h('button', 'kco-upload-clear', '✕');
      clear.type = 'button';
      done.appendChild(thumb);
      done.appendChild(fname);
      done.appendChild(clear);
      zone.appendChild(idle);
      zone.appendChild(done);
      input.addEventListener('change', function () {
        if (input.files.length) {
          var f = input.files[0];
          fname.textContent = f.name;
          if (/^image\//.test(f.type)) {
            thumb.src = URL.createObjectURL(f);
            thumb.style.display = '';
          } else {
            thumb.style.display = 'none';
          }
          idle.style.display = 'none';
          done.style.display = '';
          zone.classList.add('is-filled');
          setValue(el.id, f.name);
        }
      });
      clear.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        input.value = '';
        idle.style.display = '';
        done.style.display = 'none';
        zone.classList.remove('is-filled');
        setValue(el.id, '');
      });
      wrap.appendChild(zone);
      var help = helpText(el);
      if (help) wrap.appendChild(help);
      return wrap;
    }
  };

  function switchRow(el, ov, text, noBadge) {
    var lab = h('label', 'kco-switch-row');
    var input = h('input');
    input.type = 'checkbox';
    var track = h('span', 'kco-switch');
    track.appendChild(h('span', 'kco-switch-knob'));
    lab.appendChild(input);
    lab.appendChild(track);
    if (text) lab.appendChild(h('span', 'kco-switch-label', text));
    var badge = noBadge ? null : priceBadge(ov);
    if (badge) lab.appendChild(badge);
    input.addEventListener('change', function () {
      setValue(el.id, input.checked ? ov.value : '');
    });
    return lab;
  }

  function registerEl(el, node, groupId) {
    els[el.id] = el;
    nodes[el.id] = node;
    if (groupId) parentOf[el.id] = groupId;
  }

  function renderPlain(el, container, groupId) {
    var r = renderers[el.type];
    if (!r) return null;
    var node = r(el);
    node.classList.add('kco-el');
    node.dataset.kcoId = el.id;
    registerEl(el, node, groupId);
    if (el.inline) {
      var row = container.querySelector(':scope > .kco-inline-row[data-row="' + el.inline + '"]');
      if (!row) {
        row = h('div', 'kco-inline-row');
        row.dataset.row = el.inline;
        container.appendChild(row);
      }
      row.appendChild(node);
    } else {
      container.appendChild(node);
    }
    return node;
  }

  /* expand groups render as a clean section of addon CARDS:
     each checkbox => card (header: title + price chip + switch; body: its dependent fields) */
  function renderExpandGroup(el, container, groupId) {
    var g = h('div', 'kco-group kco-group--expand');
    registerEl(el, g, groupId);
    var title = disp(el).split(' - ')[0];
    g.appendChild(h('h3', 'kco-expand-title', title));
    var kids = el.elements || [];
    var i = 0;
    while (i < kids.length) {
      var kid = kids[i];
      if (kid.type === 'divider') { i++; continue; }
      if (kid.type === 'checkbox') {
        var card = h('div', 'kco-card');
        var head = h('div', 'kco-card-head');
        head.appendChild(h('span', 'kco-card-title', disp(kid).split(' - ')[0]));
        var ov = (kid.values || [])[0] || {};
        var badge = priceBadge(ov);
        if (badge) head.appendChild(badge);
        var sw = switchRow(kid, ov, null, true);
        sw.classList.add('kco-card-switch');
        head.appendChild(sw);
        card.appendChild(head);
        registerEl(kid, card, el.id);
        card.classList.add('kco-el');
        card.dataset.kcoId = kid.id;
        var body = h('div', 'kco-card-body kco-hidden');
        var depIds = [];
        var inCard = {};
        inCard[kid.id] = true;
        var j = i + 1;
        while (j < kids.length) {
          var dep = kids[j];
          if (dep.type === 'divider') { j++; continue; }
          // element belongs to this card if its condition references anything already in the card
          // (chains supported: a nested toggle like "Drugi tekst" pulls its own fields in too)
          var refs = dep.clo && dep.clo.whens && dep.clo.whens.some(function (w) { return inCard[w.select]; });
          if (!refs) break;
          renderPlain(dep, body, el.id);
          depIds.push(dep.id);
          inCard[dep.id] = true;
          j++;
        }
        if (depIds.length) {
          card.appendChild(body);
          cardBodies.push({ body: body, ids: depIds });
        }
        container.appendChild(card);
        i = j;
      } else {
        renderPlain(kid, container, el.id);
        i++;
      }
    }
    container.appendChild(g); // keeps node registered for CLO (empty marker)
    g.style.display = 'none';
    return g;
  }

  function renderElement(el, container, groupId) {
    if (el.type === 'group') {
      if (el.style === 'expand') {
        var wrapper = h('div', 'kco-expand-wrap');
        renderExpandGroup(el, wrapper, groupId);
        container.appendChild(wrapper);
        return;
      }
      var g = h('div', 'kco-group');
      registerEl(el, g, groupId);
      (el.elements || []).forEach(function (kid) { renderElement(kid, g, el.id); });
      container.appendChild(g);
      return;
    }
    renderPlain(el, container, groupId);
  }

  /* ---------- defaults ---------- */
  function applyDefaults() {
    Object.keys(els).forEach(function (id) {
      var el = els[id];
      var dv = (el.default_value && el.default_value[0]) || '';
      if (!dv) return;
      values[id] = dv;
      var n = nodes[id];
      if (!n) return;
      if (el.type === 'image-swatches') {
        var tiles = n.querySelectorAll('.kco-swatch');
        (el.values || []).forEach(function (ov, i) {
          if (norm(ov.value) === norm(dv) && tiles[i]) {
            tiles[i].classList.add('is-active');
            if (ov.pv) SELECTED_VARIANT = ov.pv;
            else if (ov.abs_on_base) SELECTED_VARIANT = BASE_VARIANT;
            else if (ov.variant_price && parseFloat(ov.variant_price)) {
              var sp = n.querySelector('.kco-sel-price');
              if (sp) sp.textContent = '(+ ' + MONEY(parseFloat(ov.variant_price) * 100) + ')';
            }
          }
        });
      } else if (el.type === 'buttons') {
        var pills = n.querySelectorAll('.kco-pill');
        (el.values || []).forEach(function (ov, i) {
          if (norm(ov.value) === norm(dv) && pills[i]) pills[i].classList.add('is-active');
        });
      } else if (el.type === 'image-dropdown' || el.type === 'google-font') {
        var bt = n.querySelector('.kco-dropdown-btn span');
        if (bt) bt.textContent = dv;
        if (el.type === 'google-font') {
          loadFontCss(dv);
          if (bt) bt.style.setProperty('font-family', '"' + dv + '"', 'important');
          applyFont(el, dv);
        }
        if (el.type === 'image-dropdown') {
          (el.values || []).forEach(function (ov) {
            if (norm(ov.value) === norm(dv) && ov.img) {
              var bi = n.querySelector('.kco-dropdown-btn-img');
              if (bi) { bi.src = kcoThumb(ov.img); bi.style.display = ''; }
            }
          });
        }
      } else if (el.type === 'text' || el.type === 'textarea') {
        var inp = n.querySelector('input,textarea');
        if (inp) inp.value = dv;
      }
    });
  }

  /* ---------- live prices ---------- */
  function refreshLivePrices() {
    // base product variants (real pricing for product types)
    if (PRODUCT_HANDLE) {
      fetch(ROOT + 'products/' + PRODUCT_HANDLE + '.js').then(function (r) { return r.json(); }).then(function (prod) {
        PRODUCT_DATA = prod;
        Object.keys(els).forEach(function (id) {
          (els[id].values || []).forEach(function (ov) {
            if (!ov.pv) return;
            var live = (prod.variants || []).filter(function (v) { return String(v.id) === String(ov.pv); })[0];
            if (live) {
              ov.pv_price = (live.price / 100).toFixed(2);
              (badgeRefs['pv' + ov.pv] || []).forEach(function (b) { b.textContent = MONEY(live.price); });
            }
          });
        });
        updatePrice();
      }).catch(function (e) { console.warn('[kc-options] base price', e); });
    }
    // addon products
    var handles = {};
    Object.keys(els).forEach(function (id) {
      (els[id].values || []).forEach(function (ov) {
        if (ov.variant_id && ov.ph) handles[ov.ph] = true;
      });
    });
    Object.keys(handles).forEach(function (ph) {
      fetch(ROOT + 'products/' + ph + '.js').then(function (r) {
        if (!r.ok) throw new Error(ph + ' ' + r.status);
        return r.json();
      }).then(function (prod) {
        var byId = {};
        (prod.variants || []).forEach(function (v) { byId[v.id] = v; });
        Object.keys(els).forEach(function (id) {
          (els[id].values || []).forEach(function (ov) {
            if (!ov.variant_id || ov.ph !== ph) return;
            var live = byId[ov.variant_id];
            if (!live || !live.available) {
              delete ov.variant_id;
              ov.variant_price = '0';
              return;
            }
            ov.variant_price = (live.price / 100).toFixed(2);
            (badgeRefs[live.id] || []).forEach(function (b) { b.textContent = '+' + MONEY(live.price); });
          });
        });
        updatePrice();
      }).catch(function (e) { console.warn('[kc-options] live price', e); });
    });
  }

  /* ---------- validation ---------- */
  function validate() {
    var firstBad = null;
    Object.keys(els).forEach(function (id) {
      var el = els[id];
      if (!el.required || el.type === 'group') return;
      if (!isVisible(id)) return;
      if (!values[id]) {
        nodes[id].classList.add('kco-invalid');
        if (!firstBad) firstBad = nodes[id];
      }
    });
    if (firstBad) {
      firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      showToast(KCO_US ? 'Please fill in the required fields marked *' : 'Uzupełnij wymagane pola oznaczone *');
      return false;
    }
    return true;
  }
  function showToast(msg) {
    var t = root.querySelector('.kco-toast');
    if (!t) {
      t = h('div', 'kco-toast');
      root.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-visible');
    setTimeout(function () { t.classList.remove('is-visible'); }, 3500);
  }

  /* ---------- add to cart ---------- */
  function collectProperties() {
    var props = {};
    Object.keys(els).forEach(function (id) {
      var el = els[id];
      if (el.type === 'group' || el.type === 'heading' || el.type === 'divider' || el.type === 'size-chart' || el.type === 'spacing') return;
      if (el.type === 'file') return; // the real file input is cloned into the form instead
      if (!isVisible(id)) return;
      var v = values[id];
      if (!v) return;
      var k = el.label_on_cart || el.id;
      if (!KCO_US) { props[k] = v; return; }
      var ek = cartKeyEn(el), ev = cartValEn(el, v), n = 2, base = ek;
      while (props.hasOwnProperty(ek)) ek = base + ' ' + (n++);
      props[ek] = ev;
      if (ek !== k || ev !== v) props['_' + k] = v;
    });
    return props;
  }
  function submitCart(btn) {
    if (!validate()) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    var group = String(Date.now());
    var q = qty();
    var addons = selectedAddons().map(function (a) {
      return {
        id: a.variant_id,
        quantity: q,
        properties: {
          '_gpo_parent_product_group': group,
          '_gpo_field_name': a.field
        }
      };
    });
    var addAddons = addons.length
      ? fetch(ROOT.replace(/\/$/, '') + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: addons })
        }).then(function (r) {
          if (!r.ok) throw new Error('addon add failed: ' + r.status);
          return r.json();
        })
      : Promise.resolve();

    addAddons.then(function () {
      var form = document.createElement('form');
      form.action = ROOT.replace(/\/$/, '') + '/cart/add'; // market prefix (/en-us) keeps US buyers in the US cart
      form.method = 'post';
      form.enctype = 'multipart/form-data';
      form.style.display = 'none';
      function add(name, value) {
        var i = document.createElement('input');
        i.type = 'hidden';
        i.name = name;
        i.value = value;
        form.appendChild(i);
      }
      add('id', SELECTED_VARIANT || BASE_VARIANT);
      add('quantity', q);
      var props = collectProperties();
      Object.keys(props).forEach(function (k) { add('properties[' + k + ']', props[k]); });
      add('properties[_has_gpo]', SET_ID);
      add('properties[_gpo_product_group]', group);
      root.querySelectorAll('input[data-kco-file]').forEach(function (fi) {
        if (!fi.files.length) return;
        if (fi.dataset.kcoFileId && !isVisible(fi.dataset.kcoFileId)) return;
        var clone = fi.cloneNode();
        var dt = new DataTransfer();
        for (var i = 0; i < fi.files.length; i++) dt.items.add(fi.files[i]);
        clone.files = dt.files;
        clone.name = 'properties[' + fi.dataset.kcoFile + ']';
        form.appendChild(clone);
      });
      var kcoGo = function () { document.body.appendChild(form); form.submit(); };
      var kcoHook = window.KCO && window.KCO.hooks.beforeSubmit;
      if (kcoHook) Promise.resolve().then(function () { return kcoHook(form); }).catch(function (e) { console.warn('[KCO] beforeSubmit', e); }).then(kcoGo);
      else kcoGo();
    }).catch(function (err) {
      console.error('[kc-options]', err);
      btn.disabled = false;
      btn.classList.remove('is-loading');
      showToast(KCO_US ? 'Could not add to cart. Please try again.' : 'Nie udało się dodać do koszyka. Spróbuj ponownie.');
    });
  }

  /* page layout: Ilość + stars live INSIDE the glass section; theme price hidden;
     info-column order = options -> badges -> tabs (collapsed) -> videos */
  function integrateThemeLayout() {
    var col = root.closest('.productView-product') || root.parentElement;
    if (!col) return;
    var footer = root.querySelector('.kco-footer');
    var totalRow = footer && footer.querySelector('.kco-total-row');
    var atc = footer && footer.querySelector('.kco-atc');
    if (footer && totalRow) {
      // one line: Ilość (left) | Razem (right)
      var bar = h('div', 'kco-buy-bar');
      footer.insertBefore(bar, totalRow);
      var qty = col.querySelector('.quantity_selector');
      if (qty) {
        var qwrap = qty.closest('.productView-moreItem');
        qty.classList.add('kco-qty');
        bar.appendChild(qty);
        if (qwrap) qwrap.style.display = 'none';
      }
      bar.appendChild(totalRow);
      var priceEl = col.querySelector('.price.price--medium, .price');
      if (priceEl) {
        var pw = priceEl.closest('.productView-moreItem') || priceEl;
        pw.style.display = 'none';
      }
      // the Loox stars block that sat under the theme price -> UNDER the add-to-cart button
      var afterRoot = false;
      var kids = Array.prototype.slice.call(col.children);
      for (var i = 0; i < kids.length; i++) {
        if (kids[i] === root) { afterRoot = true; continue; }
        if (afterRoot && kids[i].classList && kids[i].classList.contains('shopify-block') && kids[i].querySelector('.loox-rating')) {
          kids[i].classList.add('kco-stars');
          footer.appendChild(kids[i]);
          break;
        }
      }
    }
    // badges -> tabs -> videos
    var tab = col.querySelector(':scope > product-tab, :scope > .productView-tab');
    var vids = col.querySelector(':scope > .kc-videos');
    if (tab && vids) {
      var anchor = (vids.previousElementSibling && vids.previousElementSibling.tagName === 'STYLE') ? vids.previousElementSibling : vids;
      col.insertBefore(tab, anchor);
    }
    // collapse all tabs by default (and again after the theme's tab script initializes)
    function collapseTabs() {
      if (!tab) return;
      tab.querySelectorAll('.tab-content.is-active').forEach(function (n) { n.classList.remove('is-active'); });
      tab.querySelectorAll('[class*="tab-link"].is-active, [class*="tab-title"].is-active, .tab-heading.is-active').forEach(function (n) { n.classList.remove('is-active'); });
      tab.classList.add('kco-tabs');
    }
    collapseTabs();
    setTimeout(collapseTabs, 900);
    setTimeout(collapseTabs, 2200);
  }

  /* ---------- boot ---------- */
  fetch(CONFIG_URL)
    .then(function (r) { return r.json(); })
    .then(function (cfg) {
      var p = cfg.products[PRODUCT_ID];
      if (!p) return;
      // set definitions live inline (first products) or in bundle assets (batch rollout);
      // reuse the config's ?v= so bundle updates bust the CDN cache together with the config
      if (p.bundle) {
        var ver = (CONFIG_URL.indexOf('?') >= 0) ? CONFIG_URL.slice(CONFIG_URL.indexOf('?')) : '';
        return fetch(ASSET_BASE + p.bundle + ver).then(function (r) { return r.json(); })
          .then(function (b) { return { p: p, set: b.sets[p.set] }; });
      }
      return { p: p, set: cfg.sets[p.set] };
    })
    .then(function (res) {
      if (!res || !res.set) return;
      var p = res.p;
      SET = res.set;
      SET_ID = p.set;
      BASE_VARIANT = p.base_variant;
      SELECTED_VARIANT = p.base_variant;
      BASE_PRICE = p.base_price;
      // resolve per-product real variants for the product-type picker;
      // values without a real variant keep their Globo addon pricing as fallback
      (function resolvePv(els) {
        els.forEach(function (el) {
          (el.values || []).forEach(function (ov) {
            if (ov.pv_from_index) {
              var info = (p.pv || {})[ov.value];
              if (info) {
                ov.pv = info.id;
                ov.pv_price = info.price;
                delete ov.variant_id;
                delete ov.variant_price;
                delete ov.ph;
              } else if (ov.variant_id) {
                // no real variant -> Globo addon on TOP OF THE BASE variant;
                // shown as an absolute price (base + addon), not "+90"
                ov.abs_on_base = true;
              }
            }
          });
          if (el.elements) resolvePv(el.elements);
        });
      })(SET.elements);
      reorderCommonFields(SET.elements);
      if (KCO_US) stripUsHidden(SET.elements);
      pairFontColor(SET.elements);

      document.body.classList.add('kc-options-active');

      var formWrap = h('div', 'kco-form');
      SET.elements.forEach(function (el) { renderElement(el, formWrap, null); });

      var footer = h('div', 'kco-footer');
      var totalRow = h('div', 'kco-total-row');
      totalRow.appendChild(h('span', 'kco-total-label', KCO_US ? 'Total:' : 'Razem:'));
      totalRow.appendChild(h('span', 'kco-total', MONEY(BASE_PRICE)));
      var extra = h('div', 'kco-total-extra', '');
      extra.style.display = 'none';
      var atc = h('button', 'kco-atc', KCO_US ? 'Add to cart' : 'Dodaj do koszyka');
      atc.type = 'button';
      atc.addEventListener('click', function () { submitCart(atc); });
      footer.appendChild(totalRow);
      footer.appendChild(extra);
      footer.appendChild(atc);
      formWrap.appendChild(footer);

      root.appendChild(formWrap);
      applyDefaults();
      refresh();
      refreshLivePrices();

      // polish the theme quantity label
      document.querySelectorAll('.quantity__label, label[for*="uantity"]').forEach(function (n) {
        if (/quantity|ilo/i.test(n.textContent)) n.textContent = KCO_US ? 'Qty:' : 'Ilość:';
      });

      var host = document.querySelector('[id*="globo_product_options"]');
      if (host && host.parentNode) {
        host.parentNode.insertBefore(root, host);
      } else {
        var buy = document.querySelector('.product-form__buttons, .product-form');
        if (buy && buy.parentNode) buy.parentNode.insertBefore(root, buy);
      }
      integrateThemeLayout();
      root.classList.add('is-ready');
      if (window.KCO) { window.KCO.ready = true; document.dispatchEvent(new CustomEvent('kco:ready')); }
    })
    .catch(function (err) { console.error('[kc-options] config load failed', err); });
})();
